module.exports = __webpack_public_path__ + "92fc5bfee8731ee95d05542b26018f43.png";